import { createStore } from "vuex";
import * as getters from "./getters";
import * as actions from "./actions";
import mutations from "./mutations";
import { categories, fakeArticle } from "@/utils/constants";

const state = {
  categories: categories,

  activeArticle: fakeArticle,

  // can be only "dark" or "light"
  theme:
    typeof localStorage !== "undefined"
      ? localStorage.getItem("theme") || "dark"
      : "dark",

  weather: 25,
  currency: 10547,
  football: [
    {
      home_team: "KPV-j",
      away_team: "EIF",
      home_goal: 0,
      away_goal: 0,
      home_icon: "https://media.api-sports.io/football/teams/10199.png",
      away_icon: "https://media.api-sports.io/football/teams/2078.png",
      date: new Date(),
      creation_date: "2021-09-15T19:51:03.477527+05:00",
      league_logo: "https://media.api-sports.io/football/leagues/99.png",
      league_name: "J. League Div.2"
    },
    {
      home_team: "Nõmme United",
      away_team: "Elva",
      home_goal: 0,
      away_goal: 0,
      home_icon: "https://media.api-sports.io/football/teams/10059.png",
      away_icon: "https://media.api-sports.io/football/teams/3516.png",
      date: "2021-09-15T14:30:00+00:00",
      creation_date: "2021-09-15T19:51:03.483030+05:00",
      league_logo: "https://media.api-sports.io/football/leagues/99.png",
      league_name: "J. League Div.2"
    },
    {
      home_team: "Flora II",
      away_team: "Maardu",
      home_goal: 1,
      away_goal: 2,
      home_icon: "https://media.api-sports.io/football/teams/3518.png",
      away_icon: "https://media.api-sports.io/football/teams/3527.png",
      date: "2021-09-15T14:30:00+00:00",
      creation_date: "2021-09-15T19:51:03.484428+05:00",
      league_logo: "https://media.api-sports.io/football/leagues/99.png",
      league_name: "J. League Div.2"
    },
    {
      home_team: "Asker",
      away_team: "Fløya",
      home_goal: 0,
      away_goal: 0,
      home_icon: "https://media.api-sports.io/football/teams/6967.png",
      away_icon: "https://media.api-sports.io/football/teams/6984.png",
      date: "2021-09-15T14:30:00+00:00",
      creation_date: "2021-09-15T19:51:03.485825+05:00",
      league_logo: "https://media.api-sports.io/football/leagues/99.png",
      league_name: "J. League Div.2"
    },
    {
      home_team: "Pakhtakor",
      away_team: "Navbahor",
      home_goal: 0,
      away_goal: 0,
      home_icon: "https://media.api-sports.io/football/teams/4220.png",
      away_icon: "https://media.api-sports.io/football/teams/4216.png",
      date: "2021-09-15T14:00:00+00:00",
      creation_date: "2021-09-15T19:51:03.487295+05:00",
      league_logo: "https://media.api-sports.io/football/leagues/99.png",
      league_name: "J. League Div.2"
    },
    {
      home_team: "Dubrava Zagreb",
      away_team: "NK Osijek II",
      home_goal: 1,
      away_goal: 0,
      home_icon: "https://media.api-sports.io/football/teams/6255.png",
      away_icon: "https://media.api-sports.io/football/teams/1486.png",
      date: "2021-09-15T14:30:00+00:00",
      creation_date: "2021-09-15T19:51:03.488530+05:00",
      league_logo: "https://media.api-sports.io/football/leagues/99.png",
      league_name: "J. League Div.2"
    }
  ],
  population: 7892464973,
  movies: [],

  // Registration
  userModel: {
    name: "",
    surname: "",
    phone: "",
    email: "",
    username: "",
    password: ""
  },

  // Main
  latestNews: [],
  currentPage: 0,
  newsCount: null,

  uzbekistanNews: [],

  // Search
  searchNews: [],
  searchPage: 0,
  searchCount: null,
  searchReccomend: [],
  searchReccomendPage: 0,
  searchReccomendCount: null,

  // Auth
  access:
    typeof localStorage !== "undefined" ? localStorage.getItem("access") : null,
  refresh:
    typeof localStorage !== "undefined"
      ? localStorage.getItem("refresh")
      : null,

  // Staff
  user: {},
  newArticle: {},
  subCategories: [],
  tags: [],

  // Staff News
  staffNews: [],

  staffPage: 0,
  staffCount: null,

  // admin News
  adminNews: [],
  adminPage: 0,
  adminCount: null,
  authorsList: [],

  // Staff Team
  employees: [],
  employeesPage: 0,
  employeesCount: null,

  journalists: [],
  journalistsPage: 0,
  journalistsCount: null,
};

export default function () {
  return createStore({
    state,
    getters,
    actions,
    mutations
  });
}
